import 'magnific-popup'


export default {
	init() {

		const $infoPopup = $("#info-popup")
		if ($infoPopup.length) {
			setTimeout(() => {
				checkAndSetCookie()
			}, 1500);
		}

		// Function to open the modal
		function openInfoPopup() {
			$.magnificPopup.open({
				items: {
					src: '#info-popup'
				},
				type: 'inline',
				preloader: false,
				modal: true,
			});
		}

		// Function to check cookie and set it if it doesn't exist
		function checkAndSetCookie() {
			const cookieName = "info-popup";
			const cookieValue = "true";
			const cookieHours = 24;

			if (!getCookie(cookieName)) {
				// Cookie does not exist, so set it
				setCookie(cookieName, cookieValue, cookieHours);
				// Call the function to open the modal
				openInfoPopup();
			}
		}


		// Function to set a cookie
		function setCookie(name, value, hours) {
			const date = new Date();
			date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		}
		
		
		// Function to get a cookie
		function getCookie(name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for(let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		}


	}
}
